(function () {
  angular
    .module('specsguardApp')
    .factory('sgNavigationLabelReplacesFactory', sgNavigationLabelReplaces);

  sgNavigationLabelReplaces.$inject = ['Labels'];

  function sgNavigationLabelReplaces (Labels) {
    return {
      projectTitle (str, project) {
        return str
          .replace('[ProjectName]', project.name);
      },
      projectSubTitle (str, areaName, basicAreaName, buildingName) {
        return str
          .replace('[AreaName]', areaName)
          .replace('[BasicAreaName]', basicAreaName)
          .replace('[BuildingName]', buildingName)
          .replace('[Beheer]', Labels.getLabel('administration'))
          .replace('[Ruimteboek]', Labels.getLabel('specbook'))
          .replace('[Specificaties]', Labels.getPlural('specification'))
          .replace('[Gebouwinformatie]', Labels.getLabel('buildinginformation'))
          .replace('[Gebouw toevoegen]', Labels.getLabel('addbuilding'))
          .replace('[PvE document]', Labels.getLabel('pvedocument'))
          .replace('[Projectinformatie]', Labels.getLabel('projectinformation'))
          .replace('[Project overzicht]', Labels.getLabel('projectoverview'))
          .replace('[Ruimte template overzicht]', Labels.getLabel('areatemplateoverview'))
          .replace('[bewerken]', Labels.getLabelLowerCase('edit'))
          .replace('[Ruimteblad]', Labels.getLabel('areasheet'))
          .replace('[Ruimtestaat]', Labels.getLabel('arealist'))
          .replace('[Documents]', Labels.getPluralCapFirstLetter('projectdocument'));
      },

      tenants (menu, trans, menuCtrl) {
        menuCtrl.pageTitle = menu.title
          .replace('[Tenants]', Labels.getPlural('tenant'));
        menuCtrl.subTitle = menu.subtitle
          .replace('[Tenants overview]', Labels.getPlural('tenantsoverview'));
      },

      user (menu, trans, menuCtrl) {
        menuCtrl.pageTitle = menu.title
          .replace('[Gebruiker]', Labels.getLabel('user'))
          .replace('[Gebruikers]', Labels.getPlural('user')) || '';
        menuCtrl.subTitle = menu.subtitle
          .replace('[Toevoegen]', Labels.getLabel('add'))
          .replace('[Gebruikersprofiel]', Labels.getLabel('userprofile'))
          .replace('[Overzicht]', Labels.getLabel('overview')) || '';
      },

      userDetail (menu, trans, menuCtrl) {
        trans.injector().getAsync('user').then((user) => {
          menuCtrl.pageTitle = menu.title
            .replace('[UserName]', user.fullName);
          menuCtrl.subTitle = menu.subtitle
            .replace('[Gebruikersprofiel]', Labels.getLabel('userprofile'));
          menuCtrl.initial = user.nameFirst[0].toUpperCase() + user.nameLast[0].toUpperCase();
          menuCtrl.menuIcon = menu.icon;
        });
      },

      template (menu, trans, menuCtrl) {
        const title = menu.title;

        menuCtrl.pageTitle = title
          .replace('[Textual_templates]', Labels.getPlural('textualtemplate'))
          .replace('[Technical_templates]', Labels.getPlural('technicaltemplate'))
          .replace('[project_templates]', Labels.getPlural('projecttemplate'))
          .replace('[building_templates]', Labels.getPlural('buildingtemplate'));

        const subtitle = menu.subtitle;
        if (subtitle && subtitle.indexOf('[TemplateName]') > -1) {
          return trans.injector().getAsync('template').then((template) => {
            menuCtrl.subTitle = subtitle
              .replace('[TemplateName]', template.name);
          });
        }

        menuCtrl.subTitle = subtitle
          .replace('[project_templates]', Labels.getPlural('projecttemplate'))
          .replace('[Gebouwen]', Labels.getPlural('buildingtemplate'))
          .replace('[Ruimte templates]', Labels.getPlural('areatemplate'))
          .replace('[Ruimte template toevoegen]', Labels.getLabel('addareatemplate'))
          .replace('[Tekstuele specificaties]', Labels.getPlural('textualspecification'))
          .replace('[Technische specificaties]', Labels.getPlural('technicalspecification'))
          .replace('[Technisch element aanmaken / bewerken]', Labels.getLabel('addedittechnicalspecification'))
          .replace('[Modules]', Labels.getPlural('textualstructure'));

        return null;
      }
    };
  }
})();
